// Currently only applies to Trucks (Since release 1.4.0)
export const mainVehicleImageId = 'frontLeft';

export const vehicleImageIdsOrder = ['frontLeft', 'frontRight', 'backLeft', 'backRight', 'interiorTachometers', 'interiorView'];
